<template>
<div>

    <fast-table
        v-if="dataLoaded"
        :sections="sections"
        :headers="headers"
        :data="tableData"
        @click="sidebarOpen = true"
    />

    <sidebar
        v-if="sidebarOpen"
        :fed="fed"
        @updated="onUpdate($event)"
        @close="sidebarOpen = false"
    />
</div>
</template>

<script>
import FastTable from '@/components/FastTable'
import Sidebar from './components/FedSidebar'

export default {
    components: {FastTable, Sidebar, },
    computed: {
        tableData() {
            const tableData = []

            const minWage = this.fed.minimum_wages.find(w => w.is_active)
            const row = {
                id: 'fed',
                isActive: this.sidebarOpen,
                object: this.fed,
                cells: [
                    'Federal',
                    minWage ? '$' + minWage.minimum_wage : '',
                    minWage ? '$' + minWage.max_tip_credit_claimed : '',
                    this.fed.updated_on,
                ],
            }

            tableData.push(row)

            return [tableData]
        },
    },
    data() {
        return {
            fed: {},
            dataLoaded: false,
            sidebarOpen: false,

            headers: [
                {label: 'Name', classes: '', isSearchable: true, defaultSort: true},
                {label: 'Minimum Wage', classes: 'cw-3', isSearchable: false},
                {label: 'Max Tip Credit', classes: 'cw-3', isSearchable: false},
                {label: 'Last Update', classes: 'cell-date', type: 'date', isSearchable: false},
            ],
            sections: [
                {title: 'Active', defaultIsClosed: false, id: 1},
            ],
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Tax Engine / Federal')
        this.getFed()
    },
    methods: {
        getFed() {
            this.dataLoaded = false
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/admin/tax-engine/fed`).then(resp => {
                this.fed = resp
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(this.$bus.firstError(errors))
            })
        },
        onUpdate(city) {
            return this.getFed()
        },
    },
}

</script>
